import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const mediaGatewayTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'Media Gateway',
  key: 'mediaGateway',
  main: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['mgwtype', 'ipaddr', 'port'],
          ['name', 'version', 'ownnetid'],
          ['mgwuri', 'reqstate', 'insidenat'],
          ['enablejitter', '$empty', '$empty'],
          ['mediagatewaynumlist']
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      mgwtype: {
        label: 'Media Type',
        type: 'select',
        initial: 'AudioCodes',
        validation: {
          required: true,
        },
        options: [
          {
            label: 'Audio Codes',
            value: 'AudioCodes',
          },
          {
            label: 'Sonus/Ribbon',
            value: 'Sonus',
          },
          {
            label: 'Dialogic',
            value: 'Dialogic',
          },
          {
            label: 'Genband C3 MGC',
            value: 'GenbandC3',
          },
          {
            label: 'Sangoma Dialogic',
            value: 'SangomaDialogic',
          },
          {
            label: 'Ribbon C20 CSC',
            value: 'RibbonC20_CSC',
          }
        ],
      },
      ipaddr: {
        label: 'IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
            {
              type: 'IPAddress',
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      port: {
        label: 'Port',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5,
            },
            {
              type: 'Interval',
              intervals: [
                [
                  0,
                  65535,
                ],
              ],
              errorMessage: 'Must be between 0 - 65536. Please re-enter.',
            },
          ],
        },
      },
      name: {
        label: 'Name',
        hintMessage: 'Max 16 characters with no spaces',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      version: {
        label: 'Version',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 256,
            },
          ],
        },
      },
      ownnetid: {
        label: 'XCP Network ID',
        type: 'advancedSelect',
        initial: '',
        placeholder: 'Select a Network ID',
        allowCreate: true,
        options: [],
        optionsFormat: 'networkIdAndIpAddress',
        validation: {
          required: true,
          validators: [
            {
              type: 'customFunction',
              customValidationFunction: 'networkIdNotFoundValidator',
              errorMessage: 'Please select another network ID.'
            },
          ],
        },
      },
      mgwuri: {
        label: 'Management URI - FQDN',
        placeholder: 'e.g. https://10.0.0.1:443/path',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 256,
            },
            {
              type: 'URL',
              errorMessage: 'Must be a valid URL. Please re-enter.',
            },
          ],
        },
      },
      reqstate: {
        label: 'Configured State',
        type: 'select',
        initial: 'ACTIVE',
        options: [
          {
            label: 'Active',
            value: 'ACTIVE',
          },
          {
            label: 'Inactive',
            value: 'INACTIVE',
          },
        ],
        optionsTranslatable: true,
      },
      insidenat: {
        label: 'Xcipio is behind NAT',
        type: 'checkbox',
        initial: false,
      },
      mediagatewaynumlist: {
        label: 'Calling Numbers',
        type: 'tagInputCustom',
        allowCreate: true,
        initial: '',
        placeholder: 'Type a calling number and hit enter to create',
        tags: [],
      },
      enablejitter: {
        label: 'Enable Jitter',
        type: 'text',
        hide: 'true',
        initial: 'NO',
      },
    },
  },
};
